// Wallid constants
// export const CONTRACT_ADDRESS = '0x787e5fc4773cad0c45f287bf00daca402845b1b7';//old contract
export const CONTRACT_ADDRESS = '0x20B584e9F6f03F33a41434D76DB75EB11908c057'; //old contract

export const DEFAULT_PASSWORD = '20THIS_WILL_USE_METAMASK_SECURITY18';
export const VERIFY_ID = 'https://api.wallid.io/api/v1/verify';
export const IDENTITIES_URL = 'https://api.wallid.io/api/v1/identities'; //"http://localhost:3000/api/identities" // "https://api.wallid.io/api/v1/identities"

export const ASSET_NAMES = {
  METAMASK: 'MetaMask',
  MYWALLID: 'MyWalliD',
  ENS: 'ENS',
};

export const SEND_MESSAGE = 'SEND_MESSAGE';

export const CC_PT = 'CC_PT';
export const CMD_PT = 'CMD_PT';
export const SHUFTI_PT = 'SHUFTI_CC_PT';
export const SHUFTI_INT = 'SHUFTI_CC';
export const WALLET_ADDR = 'WALLET_ADDR';

export const API_EXTRACT = 'https://api.wallid.io/api/v1/extract';
export const AUTH_CHALLENGE = 'https://api.wallid.io/api/v1/auth';

export const INTERCOM = '/sendMessage';
export const BASE_URL_API = 'https://api.wallid.io/api/v1';
export const BASE_URL_TSP = 'https://tsp.api.wallid.io/api';

export const WEBSITE_URL = window.location.host.includes('demo')
  ? 'https://dev.wallid.io/Setup/'
  : 'https://wallid.io/Setup/';

export const NO_ACCESS =
  'Caller does not have permission to execute wallet_address';

export const CC_PT_LABELS = {
  Surname: { pt: 'Sobrenome', en: 'Surname' },
  Givenname: { pt: 'Nome', en: 'Givenname' },
  Sex: { pt: 'Sexo', en: 'Sex' },
  Height: { pt: 'Altura', en: 'Height' },
  Country: { pt: 'País', en: 'Country' },
  Birthdate: { pt: 'DATA NASCI.', en: 'Birthdate' },
  CivilianIdNumber: { pt: 'N. DE CIDADÃO', en: 'CIVIL ID NO.' },
  Validityenddate: { pt: 'DATA DE VALIDADE', en: 'EXPIRY DATE' },
  PARENTS: { pt: 'Pais', en: 'PARENTS' },
  NIF: { pt: 'Contribuinte', en: 'TAX NO.' },
  NISS: { pt: 'S. SOCIAL', en: 'SOCIAL SECURITY NO.' },
  NSNS: { pt: 'N. UTENTE', en: 'HEALTH NO.' },
};

export const CMD_PT_LABELS = {
  Name: { pt: 'Nome', en: 'Name' },
  BirthDate: { pt: 'DATA NASCI.', en: 'Birthdate' },
  CivilianIdNumber: { pt: 'N. DE CIDADÃO', en: 'CIVIL ID NO.' },
};

export const SHUFTI_PT_LABELS = {
  // Card Front side
  last_name: { pt: 'Sobrenome', en: 'Surname' },
  first_name: { pt: 'Nome', en: 'Givenname' },
  height: { pt: 'Altura', en: 'Height' },
  country: { pt: 'País', en: 'Country' },
  dob: { pt: 'DATA NASCI.', en: 'Birthdate' },
  document_number: { pt: 'N. DE CIDADÃO', en: 'CIVIL ID NO.' },
  expiry_date: { pt: 'DATA DE VALIDADE', en: 'EXPIRY DATE' },
  personal_number: { pt: 'Personal Number', en: 'Personal Number' },

  // Card Back side
  parents_name: { pt: 'Pais', en: 'PARENTS' },
  fiscal_tax_number: { pt: 'Contribuinte', en: 'TAX NO.' },
  social_security_number: { pt: 'S. SOCIAL', en: 'SOCIAL SECURITY NO.' },
  health_number: { pt: 'N. UTENTE', en: 'HEALTH NO.' },
  authority: { pt: 'Autoridade', en: 'Authority' },
  issue_date: { pt: 'Data de Emissão', en: 'Issue Date' },
  place_of_birth: { pt: 'Local de nascimento', en: 'Place of Birth' },
};
